import { type MouseEvent } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';
import { truncateMiddle } from '@liminal/utils/truncate';
import { FONT_STACK_BODY } from '@liminal/brand/font-faces';

interface TransactionIdLinkProps {
  transactionId: string | null | undefined;
  full?: boolean;
  fontSize?: number | string;
}

export function TransactionIdLink({
  transactionId,
  full = false,
  fontSize = 12,
}: TransactionIdLinkProps) {
  if (!transactionId) return <>{'—'}</>;
  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
  };
  return (
    <MuiLink
      component={RouterLink}
      to={`/transactions/${transactionId}`}
      onClick={handleClick}
      underline="hover"
      sx={{ fontFamily: FONT_STACK_BODY, fontSize }}
    >
      {full ? transactionId : truncateMiddle(transactionId)}
    </MuiLink>
  );
}
